import { gql } from "@apollo/client";

export const EXPORT_REALTIME_SETTLEMENT_ORDER_DAILY_DETAIL = gql`
    mutation ExportRealtimeSettlementOrderDailyDetail($filters: RealtimeSettlementOrderDailySumFilterTypeInput) {
        exportRealtimeSettlementOrderDailyDetail(filters: $filters)
    }
`;

export interface ExportRealtimeSettlementOrderDailyDetailResponse {
    exportRealtimeSettlementOrderDailyDetail: string;
}

